import { IPublishOptionSchema } from '../../internalTypes';
import { getOptionId } from '../getOptionId';

export function getSelectedPackageId(packages: IPublishOptionSchema[]): string | null {
  const paidPackage = packages.find(({ isPaid }) => isPaid);
  const defaultPackage = packages.find(({ isDefault }) => isDefault);
  const firstPackage = packages[0];

  if (paidPackage) {
    return getOptionId(paidPackage);
  }

  if (defaultPackage) {
    return getOptionId(defaultPackage);
  }

  if (firstPackage) {
    return getOptionId(firstPackage);
  }

  return null;
}
